import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export function Admin() {
  const [users, setUsers] = useState<any[]>([]);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('viewer');
  const [totpUri, setTotpUri] = useState<string | null>(null);
  const [totpToken, setTotpToken] = useState('');

  async function refresh() { setUsers(await api.get('/auth/users')); }
  useEffect(() => { refresh().catch(() => {}); }, []);

  async function addUser() {
    await api.post('/auth/users', { email, displayName: name, password, role });
    setEmail(''); setName(''); setPassword(''); setRole('viewer');
    await refresh();
  }

  async function enrollTotp() {
    const r = await api.post('/auth/totp/enroll');
    setTotpUri(r.otpauth);
  }
  async function confirmTotp() {
    await api.post('/auth/totp/confirm', { token: totpToken });
    setTotpUri(null); setTotpToken('');
    alert('MFA enabled');
  }

  return (
    <>
      <div className="card">
        <h2>Multi-factor authentication</h2>
        {!totpUri && <button onClick={enrollTotp}>Enroll my account in TOTP</button>}
        {totpUri && (
          <>
            <p>Scan with Authenticator app, then enter the 6-digit code:</p>
            <p style={{ wordBreak: 'break-all', color: 'var(--muted)' }}>{totpUri}</p>
            <input placeholder="123456" value={totpToken} onChange={e => setTotpToken(e.target.value)} />
            <div style={{ marginTop: 8 }}><button onClick={confirmTotp}>Confirm</button></div>
          </>
        )}
      </div>

      <div className="card">
        <h2>Add user</h2>
        <div className="row">
          <div className="col"><label>Email</label><input value={email} onChange={e => setEmail(e.target.value)} /></div>
          <div className="col"><label>Display name</label><input value={name} onChange={e => setName(e.target.value)} /></div>
          <div className="col"><label>Temporary password (min 12)</label><input type="password" value={password} onChange={e => setPassword(e.target.value)} /></div>
          <div className="col"><label>Role</label>
            <select value={role} onChange={e => setRole(e.target.value)}>
              <option value="viewer">viewer</option>
              <option value="operator">operator</option>
              <option value="admin">admin</option>
            </select>
          </div>
        </div>
        <div style={{ marginTop: 12 }}><button onClick={addUser}>Create user</button></div>
      </div>

      <div className="card">
        <h2>Users</h2>
        <div className="table-wrap"><table>
          <thead><tr><th>Email</th><th>Name</th><th>Role</th><th>Provider</th><th>MFA</th><th>Last login</th><th /></tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td>{u.email || '—'}</td>
                <td>{u.display_name}</td>
                <td>
                  <select defaultValue={u.role} onChange={async e => { await api.patch(`/auth/users/${u.id}`, { role: e.target.value }); refresh(); }}>
                    <option>viewer</option><option>operator</option><option>admin</option>
                  </select>
                </td>
                <td>{u.provider}</td>
                <td>{u.totp_enabled ? <span className="pill ok">on</span> : '—'}</td>
                <td>{u.last_login_at ? new Date(u.last_login_at).toLocaleString() : '—'}</td>
                <td>
                  <button className="ghost" onClick={async () => { await api.patch(`/auth/users/${u.id}`, { disabled: !u.disabled }); refresh(); }}>
                    {u.disabled ? 'Enable' : 'Disable'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>
      </div>
    </>
  );
}
